// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3IEAp","frontPage":"styles_frontPage__3Nspu","spin":"styles_spin__3T5dX"};